module.exports = __webpack_public_path__ + "img/shop.837ad1f5.svg";